import { IPSSelectOption } from '@/types/processingSteps'
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class OrgaValidationMixin extends Vue {
  available_ts_validation_status: IPSSelectOption[] = [
    { value: "1", text: 'Pending' },
    { value: "2", text: 'Rejected' },
    { value: "3", text: 'Approved' },
    { value: "4", text: 'Not required' },
    { value: "5", text: 'Awaiting response' }
  ]

  available_sanction_list_status: IPSSelectOption[] = [
    { value: "1", text: 'Pending' },
    { value: "2", text: 'Rejected' },
    { value: "3", text: 'Approved' },
    { value: "4", text: 'Not required' },
    { value: "5", text: 'Awaiting response' }
  ]
}
